export const ACCEPT_FILE_TYPES = [
  '.png',
  '.jpeg',
  '.jpg',
  '.bmp',
  '.gif',
  '.svg',
  '.pic',
  '.tiff',
  '.xlsx',
  '.xls',
  '.zip',
  '.7z',
  '.rar',
  '.doc',
  '.docx',
  '.ppt',
  '.pptx',
  '.txt',
  '.csv',
  '.tsv',
  '.pdf',
  '.psd',
  // '.tar',
  // '.gz',
  // '.tar.gz',
  // '.tgz',
].join(',')

export const ACCEPT_FILE_REGEX =
  /\.(png|jpeg|jpg|bmp|gif|svg|pic|tiff|xlsx|xls|zip|7z|rar|doc|docx|ppt|pptx|txt|csv|tsv|pdf|psd)$/i

export const checkedFileExtension = (fileName: string) => {
  const extension = fileName.split('.')?.pop()
  const enableUpload = ACCEPT_FILE_REGEX.test(`.${extension}`)
  return extension ? enableUpload : false
}
